import { useMutation } from '@apollo/client/react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { toast } from 'react-toastify'
import {
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
} from 'src/apollo/generated/graphql'
import { RESET_PASSWORD } from 'src/apollo/qql/auth'
import { resetPasswordSchema } from 'src/pages/auth/reset-password/schema'

type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>

export const useResetPasswordPage = () => {
  const [isSended, setIsSended] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetPasswordFormValues>({
    mode: 'onChange',
    resolver: zodResolver(resetPasswordSchema),
    defaultValues: {
      email: '',
    },
  })

  const [signIn, { loading }] = useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(RESET_PASSWORD, {
    onCompleted: () => {
      toast.success('Reset link sent! Check your inbox and follow the instructions.')
      setIsSended(true)
    },
  })

  const onSubmit = (values: ResetPasswordFormValues) => {
    signIn({ variables: { input: { email: values.email } } })
  }

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    setIsSended,
    isSended,
  }
}
